import { mobilePageViewActions } from '../../services';


export const mobilePageViewDispatcher = dispatch => ({
  showSearch: () => dispatch( { type: mobilePageViewActions.SHOWSEARCH} ),

  showCart: () => dispatch( { type: mobilePageViewActions.SHOWCART} ),

  showOther: () => dispatch( { type: mobilePageViewActions.SHOWOTHER} ),

  showHomePage: () => dispatch({type: mobilePageViewActions.SHOWHOMEPAGE}),

  showSelector: () =>dispatch({type: mobilePageViewActions.SHOWSELECTOR})
});